import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.ExifTemplates = routerStyxie({ actions: ['index', 'new', 'edit']})
